var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData, } from "../dataAccess";
//============================================================================================================
//                                              SOIL TYPES
// Returns an ApiResponse which has a data object of type T in this case SoilTypeModel[]
//============================================================================================================
// Get all SoilTexture
export const getSoilTypes = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `SoilType/`;
    return getData(url);
});
// Create a new site
export const createSoilType = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `SoilType/create`;
    return createData(url, item);
});
// Update an existing site
export const updateSoilType = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `SoilType/update`;
    return updateData(url, item);
});
// Delete a site
export const deleteSoilType = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `SoilType/SoilType-delete`;
    return updateData(url, item);
});
